import React from "react";
import Navbar from "@/components/Navbar/Navbar";
import Category from "@/components/Category/Category";
import ProductList from "@/components/ProductList/ProductList";
import Footer from "@/components/Footer/Footer";

function TransitArticles() {
  // const [openIndex, setOpenIndex] = useState<number | null>(null);
  //
  // const toggleDropdown = (index: number) => {
  //   setOpenIndex(openIndex === index ? null : index);
  // };
  //
    
  return (
      <>
          <div className="App">
              <Navbar/>
              <Category/>
              <ProductList/>
              {process.env.REACT_APP_SHOW_MAINTENANCE_NOTIFICATION === 'true' && <div className="fixed inset-x-0 bottom-0 p-4 z-20">
                  <div className="rounded-lg bg-red-600 px-4 py-3 text-white shadow-lg">
                      <p className="text-center text-sm font-medium">
                          {process.env.REACT_APP_MAINTENANCE_MESSAGE}
                      </p>
                  </div>
              </div>}
              <Footer/>
          </div>
      </>
  );
}

export default TransitArticles;
